import { LocalCodingAgentRuntime } from '@this+that/models';

export interface DelegateRuntimeModelOption {
  value: string;
  labelKey: string;
}

export const CLAUDE_MODEL_OPUS = 'opus';
export const CLAUDE_MODEL_SONNET = 'sonnet';
export const CLAUDE_MODEL_HAIKU = 'haiku';

export const CODEX_MODEL_DEFAULT = '';
export const CODEX_MODEL_SOL = 'gpt-5.6-sol';
export const CODEX_MODEL_TERRA = 'gpt-5.6-terra';
export const CODEX_MODEL_LUNA = 'gpt-5.6-luna';

export const AIDER_MODEL_QWEN_7B = 'qwen2.5-coder:7b';
export const AIDER_MODEL_QWEN_14B = 'qwen2.5-coder:14b';

const CLAUDE_MODEL_OPTIONS: DelegateRuntimeModelOption[] = [
  {
    value: CLAUDE_MODEL_OPUS,
    labelKey: 'doBox.delegation.taskType.modelClaudeOpus',
  },
  {
    value: CLAUDE_MODEL_SONNET,
    labelKey: 'doBox.delegation.taskType.modelClaudeSonnet',
  },
  {
    value: CLAUDE_MODEL_HAIKU,
    labelKey: 'doBox.delegation.taskType.modelClaudeHaiku',
  },
];

const CODEX_MODEL_OPTIONS: DelegateRuntimeModelOption[] = [
  {
    value: CODEX_MODEL_DEFAULT,
    labelKey: 'doBox.delegation.taskType.modelCodexDefault',
  },
  {
    value: CODEX_MODEL_SOL,
    labelKey: 'doBox.delegation.taskType.modelCodexSol',
  },
  {
    value: CODEX_MODEL_TERRA,
    labelKey: 'doBox.delegation.taskType.modelCodexTerra',
  },
  {
    value: CODEX_MODEL_LUNA,
    labelKey: 'doBox.delegation.taskType.modelCodexLuna',
  },
];

const AIDER_MODEL_OPTIONS: DelegateRuntimeModelOption[] = [
  {
    value: AIDER_MODEL_QWEN_7B,
    labelKey: 'doBox.delegation.taskType.modelQwenCoder7b',
  },
  {
    value: AIDER_MODEL_QWEN_14B,
    labelKey: 'doBox.delegation.taskType.modelQwenCoder14b',
  },
];

export function getModelsForRuntime(
  runtime: LocalCodingAgentRuntime,
): DelegateRuntimeModelOption[] {
  switch (runtime) {
    case LocalCodingAgentRuntime.CODEX:
      return CODEX_MODEL_OPTIONS;
    case LocalCodingAgentRuntime.AIDER:
      return AIDER_MODEL_OPTIONS;
    case LocalCodingAgentRuntime.CLAUDE:
    default:
      return CLAUDE_MODEL_OPTIONS;
  }
}

export function getDefaultModelForRuntime(
  runtime: LocalCodingAgentRuntime,
): string {
  switch (runtime) {
    case LocalCodingAgentRuntime.CODEX:
      return CODEX_MODEL_DEFAULT;
    case LocalCodingAgentRuntime.AIDER:
      return AIDER_MODEL_QWEN_7B;
    case LocalCodingAgentRuntime.CLAUDE:
    default:
      return CLAUDE_MODEL_OPUS;
  }
}
